import React from 'react'
import { hapticTick } from '../../../../../_utils/haptics'
import { placeFor, hrefFor } from '../knowledge'
import { Chevron, Compass, Steps, Arrow } from './icons'

// Under a link: where it is, or what's there when the label already says where
const subFor = (label, place) => {
  const where = place.where || place.name
  if (!label || label.indexOf(where) === -1) return where
  const first = (String(place.about || '').match(/^[^.]*\.?/) || [''])[0]
  return first.length > 90 ? `${first.slice(0, 88).replace(/[\s,;]+\S*$/, '')}…` : first
}

// Places in Beu, one tap away. Only places the app knows and this person can
// open are shown; anything else is left out rather than guessed at.
export const LinksWidget = ({ block, compact, go }) => {
  const items = block.items.map(it => ({ it, place: placeFor(it.to) })).filter(x => x.place)
  if (!items.length) return null
  return (
    <div className="bw-card is-links" role="group" aria-label={block.title || 'Where to go'}>
      {block.title && <div className="bw-head"><span className="bw-kind"><Compass />{block.title}</span></div>}
      <div className="bw-rows">
        {items.map(({ it, place }) => (
          <button
            key={`${it.to}-${it.label || ''}`}
            type="button"
            className="bw-row"
            onClick={() => { hapticTick(); const h = hrefFor(it.to, it.params); if (h) go(h.path, h.state) }}
          >
            <span className="bw-row-text">
              <strong>{it.label || place.name}</strong>
              {!compact && <span>{subFor(it.label, place)}</span>}
            </span>
            <Chevron />
          </button>
        ))}
      </div>
    </div>
  )
}

// How to do something, step by step, with each step's place one tap away
export const GuideWidget = ({ block, go }) => (
  <div className="bw-card is-guide" role="group" aria-label={block.title || 'How to'}>
    <div className="bw-head"><span className="bw-kind"><Steps />{block.title || 'How to'}</span></div>
    <ol className="bw-steps">
      {block.steps.map((s, i) => {
        const place = s.to ? placeFor(s.to) : null
        return (
          <li key={`${i}-${s.text}`}>
            <span className="bw-step-n" aria-hidden>{i + 1}</span>
            <span className="bw-step-text">
              {s.text}
              {place && (
                <button type="button" className="bw-link" onClick={() => { hapticTick(); const h = hrefFor(s.to, s.params); if (h) go(h.path, h.state) }}>
                  {s.label || `Open ${place.name}`}<Arrow size={13} />
                </button>
              )}
            </span>
          </li>
        )
      })}
    </ol>
  </div>
)
